import { client } from "../../../modules/ApolloClient";
import { RefreshToken } from '../../../services/gql/refreshToken/mutation';
import type { RefreshTokenResponse } from '../types';

export interface TokenRefreshService {
  refresh(currentToken: string, refreshToken: string): Promise<{
    accessToken: string;
    refreshToken: string;
  }>;
  updateHeader(init: RequestInit, accessToken: string): RequestInit
}

export const createApolloTokenRefreshService = (): TokenRefreshService => {
  const refresh = async (currentToken: string, refreshTokenValue: string): Promise<{
    accessToken: string;
    refreshToken: string;
  }> => {
    const response = await client.mutate<RefreshTokenResponse['data']>({
      mutation: RefreshToken,
      variables: { token: refreshTokenValue },
      context: {
        headers: {
          Authorization: `Bearer ${currentToken || "expired"}`,
        },
      },
    });

    if (!response?.data?.refreshToken) {
      throw new Error('Resposta de refresh token inválida');
    }

    const { access_token, refresh_token } = response.data.refreshToken;

    return {
      accessToken: access_token,
      refreshToken: refresh_token
    };
  };

  const updateHeader = (init: RequestInit, accessToken: string) => {
    const headers = new Headers(init.headers || {});
    headers.set("Authorization", `Bearer ${accessToken}`);
    return { ...init, headers }
  }

  return { refresh, updateHeader };
};
